var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clone-item-button",on:{"click":function($event){return _vm.cloneItem()}}},[_c('img',{attrs:{"src":require("../assets/duplicate.svg")}}),_c('div',{staticClass:"button-descriptor"},[_vm._v("Clone item")])])}
var staticRenderFns = []

export { render, staticRenderFns }